import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Stack, Box } from "@atlaskit/primitives";
import Button from "@atlaskit/button/new";
import AddIcon from "@atlaskit/icon/core/add";
import { HelperMessage } from "@atlaskit/form";
import { doBackup } from "../redux/actions/backupRestoreActions";
const BackupFlowButton = ({ flowId }) => {
  const dispatch = useDispatch();

  const [isDisabled, setIsDisabled] = useState(false);

  const onClickBackup = () => {
    console.log(flowId);
    dispatch(
      doBackup(
        "flow",
        flowId,
        "Backup started in the background and will be visible in the Restore dropdown in a few seconds or after refreshing the page"
      )
    );
    setIsDisabled(true);
    console.log("Backup started in the background and will be visible in the Restore dropdown in a few seconds after refreshing the page");
    setTimeout(() => {
      setIsDisabled(false);
    }, 10000);
  };

  return (
    <Stack>
      <Box>
        <Button onClick={onClickBackup} iconBefore={AddIcon} isDisabled={isDisabled}>
          Create new backup
        </Button>
      </Box>

      <HelperMessage>Click the button to create a backup for the flow.</HelperMessage>
    </Stack>
  );
};

export default BackupFlowButton;
